<div
  class="interview-status clickable"
  role="button"
  tabindex="0"
  title="View candidates"
  (click)="navigateToCandidates()"
  (keydown.enter)="navigateToCandidates()"
  (keydown.space)="navigateToCandidates(); $event.preventDefault()"
>
  <div class="is-head">
    <div class="is-title">
      <span class="hdr-ic"><i class="material-icons">insights</i></span>
      <h2>Interview Status</h2>
      <i class="material-icons is-arrow">chevron_right</i>
    </div>
    <div class="is-tools" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <select class="native-month" aria-label="Month" (change)="onMonthChange($any($event.target).value)">
        <option *ngFor="let opt of month" [value]="opt.label" [selected]="opt.selected">{{ opt.label }}</option>
      </select>
    </div>
  </div>

  <div class="funnel">
    <div class="fstep">
      <div class="top">
        <span class="l"><span class="ic g">📋</span> Positions Opened</span>
        <span class="v">{{ totalPositions }}</span>
      </div>
      <div class="fbar"><i [style.width.%]="(totalPositions / funnelMax) * 100" style="background:#17a06a"></i></div>
    </div>
    <div class="fstep">
      <div class="top">
        <span class="l"><span class="ic b">📨</span> Profiles Submitted</span>
        <span class="v">{{ totalProfiles }}</span>
      </div>
      <div class="fbar"><i [style.width.%]="(totalProfiles / funnelMax) * 100" style="background:#2f7ad1"></i></div>
    </div>
    <div class="fstep">
      <div class="top">
        <span class="l"><span class="ic a">⏳</span> Onboard Pending</span>
        <span class="v">{{ onboardPending }}</span>
      </div>
      <div class="fbar"><i [style.width.%]="(onboardPending / funnelMax) * 100" style="background:#d99400"></i></div>
    </div>
  </div>
</div>
